import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'motion/react';
import processData from '../../data/creativeProcessData.json';

const Process = () => {
  const stepVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: (index) => ({
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, delay: index * 0.2, ease: "easeOut" }
    })
  }

  const statVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (index) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, delay: index * 0.1 }
    })
  }

  return (
    <section className="section-lg bg-light position-relative overflow-hidden">
      <div className="process-bg-decoration"></div>
      
      <Container className="position-relative">
        <div className="service-heading mb-3">
          <motion.h6 className="underline-after text-center position-relative z-0"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="position-relative z-1 bg-white text-primary px-3">OUR PROCESS</span>
          </motion.h6>
          <motion.h2 className="d-block text-gradiant text-center fw-semibold display-5"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Transform Ideas Into Reality
          </motion.h2>    
        </div>

        <div className="process-timeline">
          <Row className="justify-content-center">
            <Col xs={12} xl={10}>
              <div className="timeline-line d-none d-lg-block"></div>
              <div className="timeline-line-mobile d-lg-none"></div>

              <Row className="g-4 g-lg-5">
                {processData.steps.map((step, index) => (
                  <motion.div className={step.position === 'left' ? 'col-12 col-lg-6' : 'col-12 col-lg-6 offset-lg-6'}
                    key={step.id}
                    variants={stepVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    custom={index}
                  >
                    <div className="process-step" data-step={step.id}>
                      <motion.div className={`process-circle process-circle-${step.position}`}
                        whileHover={{ scale: 1.2, rotate: 360 }}
                        transition={{ duration: 0.5 }}
                      >
                        <span className="process-number">{step.number}</span>
                        <div className="process-pulse"></div>
                      </motion.div>
                      <motion.div whileHover={{ y: -5, transition: { duration: 0.3 } }}>
                        <Card className="process-card h-100">
                          <Card.Body>
                            <h4 className="fw-bold mb-3">{step.title}</h4>
                            <p className="text-muted mb-3">{step.description}</p>
                            <ul className="process-list">
                              {step.items.map((item, idx) => (
                                <motion.li key={idx}
                                  initial={{ opacity: 0, x: -10 }}
                                  whileInView={{ opacity: 1, x: 0 }}
                                  viewport={{ once: true }}
                                  transition={{ delay: idx * 0.1 + 0.3 }}
                                >
                                  <i className="bi bi-check-circle-fill text-primary"></i> {item}
                                </motion.li>
                              ))}
                            </ul>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </div>
                  </motion.div>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        <Row className="mt-5 pt-5">
          <Col xs={12}>
            <div className="process-stats-wrapper">
              <Row className="g-4 text-center">
                {processData.stats.map((stat, index) => (
                  <Col key={stat.id} xs={6} md={3}>
                    <motion.div className="stat-item"
                      variants={statVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true }}
                      custom={index}
                      whileHover={{ y: -5, scale: 1.05, transition: { duration: 0.3 } }}
                    >
                      <h3 className="text-gradiant fw-bold mb-2">{stat.value}</h3>
                      <p className="text-muted mb-0">{stat.label}</p>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Process;
